import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import IconNoResults from "../../../assets/iconNoResults";
import { useTranslation } from 'react-i18next';
const NoResultsBanner = ({ type }) => {
    const [isActive, setIsActive] = useState(false);
    const { t, i18n } = useTranslation();
    const handleTouchClick = () => {
        setIsActive(!isActive);
    };
    const className = `button-primary button--bg-gradient-primary264g button--rounded button--full ${isActive ? 'touched_button_availability' : ''}`;
    return (_jsxs("div", { className: "no_error_container", children: [_jsx(IconNoResults, {}), _jsx("p", { className: "no_results_text", children: type == "search" ? t("no_results_banner") : t("no_result_filters") }), _jsx("a", { href: "/", children: _jsx("button", { className: className, onTouchEnd: handleTouchClick, onTouchStart: handleTouchClick, children: t("edit_search") }) })] }));
};
export default NoResultsBanner;
